// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, TextField, Typography } from '@mui/material';
import { useEffect, useState, forwardRef } from 'react'; // Added forwardRef
import { black500 } from '../../../constants/color';
import { palette } from '../../../../theme/palette';
const theme = palette('light');
export const QInput = forwardRef(({ label, placeholder, onChange, mt = 0, type = 'text', disabled = false, fillBackground = true, borderRadius = true, value = '', insidLabel, errormsg }, ref) => {
    const [inputValue, setInputValue] = useState(value);
    const [showTypography, setShowTypography] = useState(false);
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    const handleInputChange = (event) => {
        const value = event.target.value;
        setInputValue(value);
        if (onChange) {
            onChange(value);
        }
        setShowTypography(value !== '');
    };
    const handleInputFocus = () => {
        setShowTypography(true);
    };
    const handleInputBlur = () => {
        setShowTypography(inputValue !== '');
    };
    return (_jsxs(Box, { mt: mt, width: '100%', sx: {
            position: 'relative'
        }, children: [label && (_jsx(Typography, { variant: 'subtitle2', color: black500, children: label })), _jsx(TextField, { sx: {
                    mt: label ? '2px' : '0px',
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: fillBackground ? '#F8F8F8' : theme.common.white,
                        border: 'none',
                        borderRadius: borderRadius ? '8px' : '25px',
                        '& fieldset': {
                            border: 'none'
                        },
                        '&.Mui-focused fieldset': {
                            border: 'none'
                        },
                        '&.Mui-disabled': {
                            borderRadius: borderRadius ? '8px' : '25px',
                        }
                    }
                }, id: 'outlined-basic', InputLabelProps: { shrink: false }, variant: 'outlined', fullWidth: true, placeholder: showTypography ? '' : placeholder, value: inputValue, type: type, onChange: handleInputChange, onFocus: handleInputFocus, onBlur: handleInputBlur, disabled: disabled, inputRef: ref }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -17, left: 0 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg }) })), showTypography && insidLabel && (_jsx(Box, { sx: { position: 'absolute', top: 6, left: 16 }, children: _jsx(Typography, { fontSize: '8px', fontWeight: 500, color: '#B1B1B1', children: insidLabel }) }))] }));
});
